export type GalleryVisibility = "public" | "hidden" | "private";
export type GalleryReviewState = "draft" | "needs_review" | "approved" | "needs_info" | "archived";

export type GalleryImage = {
  id: string;
  title: string;
  subtitle: string;
  imageUrl?: string;
  alt: string;
  tone: "cyan" | "amber" | "green" | "rose" | "violet" | "slate";
  visibility: GalleryVisibility;
  reviewState: GalleryReviewState;
  sortOrder: number;
};

export const galleryImages: GalleryImage[] = [
  {
    id: "ai-term-prompt",
    title: "提示詞",
    subtitle: "把任務、條件與格式說清楚，讓 AI 更穩定地協助教學設計。",
    alt: "AI 名詞解釋圖卡：提示詞",
    tone: "cyan",
    visibility: "public",
    reviewState: "approved",
    sortOrder: 10
  },
  {
    id: "ai-term-model",
    title: "模型",
    subtitle: "能理解、生成與推理的 AI 系統核心，適合用生活化例子介紹。",
    alt: "AI 名詞解釋圖卡：模型",
    tone: "violet",
    visibility: "public",
    reviewState: "approved",
    sortOrder: 20
  },
  {
    id: "ai-term-rag",
    title: "知識檢索",
    subtitle: "讓 AI 先找到指定資料，再根據資料回答，降低憑空生成的風險。",
    alt: "AI 名詞解釋圖卡：知識檢索",
    tone: "green",
    visibility: "public",
    reviewState: "approved",
    sortOrder: 30
  },
  {
    id: "ai-term-agent",
    title: "AI 代理",
    subtitle: "能拆解任務、使用工具並逐步完成目標的 AI 協作方式。",
    alt: "AI 名詞解釋圖卡：AI 代理",
    tone: "amber",
    visibility: "public",
    reviewState: "approved",
    sortOrder: 40
  }
];

